//API serivice FUNCTIONS
import { setRoleList } from "../../Redux/features/roles.slice";
import { setPageLoader } from "../../Redux/features/utils.slice";
import { getRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
import defaultRoles from "../../Utils/defaultRoles";
import { setToLocalStorage } from "../../Helpers/helpers";
import { changeRole, changeSideOptions } from "../../Redux/features/plant.slice";
import { pageRoutes } from "../../Routing/pageRoutes";
import { access_capabilities, sidebarKeys } from "../../Utils/constants";
import {isSuperAdminByEmail} from "../../Helpers/helpers"

const  superAdmin = {
    role: 'admin',
    capabilities: [
    'view-all',
    'end-shift',
    'create-plant',
    'delete-plant',
    'create-productionLine',
    'delete-productionLine',
    'create-dynamicAdjustments-rework',
    'create-dynamicAdjustments-add-rejections',
    'view-leaderboard',
    'view-integration-details',
    'audit-trail-access',
    'product-write-access',
    'view-line-level-board',
    'edit-line-settings',
    'edit-role',
    'update-downtimeLog',
    'add-validation-access',
    'machine-access',
    'manual-entry',
    'crfs-enabled',
    'crfs-hilal-maintenance',
    'crfs-hilal-merged',
    'line-performance-monitor',
    'line-level-board',
    'change-date-filters-operator-page',
    'force-shift-stop-write',
    'support-button-write',
    'reports-access',
    'change-date-filters-line-performance',
    'change-date-filters-line-level-board',
    'product-change-line-operator',
    'rework-access',
    'add-rejections-access',
    'merge-downtime-access',
    'demerge-downtime-access',
    'mark-downtime-access',
    'change-date-filters-downtime-log',
    'edit-downtime-access',
    'line-information-access',
    'shift-access',
    'planned-downtime-access',
    'product-access',
    'weekly-access',
    'downtime-setting-access',
    'daily-target-access',
    'manual-entry-access',
    'plant-user-access',
    'plant-role-access',
    'plant-alerts-access',
    'site-champion-access',
    'generate-audit-report',
    'help-support-access',
    'user-export-report',
    'weekly-target-access',
    'weekly-target-page',
  ]
}
const { roles } = apiRoutes;

const getRolesList = async (dispatch, selector) => {
    dispatch(setPageLoader({ page: 'plantSettings', flag: true }))
    let { plant = null } = selector
    let response = await postRequest({
        endPoint: roles.list,
        body: { "conditions": {"plantId": plant?._id, "machine": null, "attributes": undefined}}
            // `{%22plantId%22:%22${plant?._id}%22,%22machine%22:${null}}&attributes=undefined`
    })

    if (response?.response.length) {
        dispatch(setRoleList({ roleList: response?.response.length ? [...defaultRoles, ...response.response] : [] }))
        dispatch(setPageLoader({ page: 'plantSettings', flag: false }))
    }
    else {
        dispatch(
            setRoleList({
                roleList: defaultRoles
            })
        )
        dispatch(setPageLoader({ page: 'plantSettings', flag: false }))
    }
}

const extractRoles = async (...params) => {
    let [dispatch, current, user, navigate] = params;
    let { plant = null } = current
    console.log(params, 'params')
    // Getting all avaiable roles.
    let currentUser = plant?.accessControl?.filter(({ email }) => email === user?.username) || []
    // If no user is found then access is not provided.
    console.log(currentUser, 'currentuser')
    if (!currentUser?.length && !isSuperAdminByEmail(user?.username))
        return navigate(pageRoutes.no_access)
    //let role = JSON.stringify(currentUser[0]?.role)    
    let response = await postRequest({
        endPoint: roles.get,
        body: {"conditions": {"role": currentUser[0]?.role,"machine": null}  }
            // `{%22role%22:%22${currentUser[0]?.role}%22,%22plantId%22:%22${plant?._id}%22}`
    })
    let availableRoles = []
    if (!response.success)
        availableRoles = []//[...defaultRoles, ...response?.response]
    else availableRoles = [response?.response]
    let currentRole = availableRoles?.filter(({ role }) => role === currentUser[0]?.role)
    if(isSuperAdminByEmail(user?.username))
        dispatch(changeRole({role:superAdmin}))
    else
        dispatch(changeRole({ role: currentRole[0] }))
    // return navigate(pageRoutes.dashboard)
}

const controlAccess = (...params) => {

    let [dispatch, current, menu, navigate] = params;
    let { role = null,user=null } = current;
    let hasAccess = []
    if (role?.capabilities.includes('view-all') || isSuperAdminByEmail(user?.username)) {
        dispatch(changeSideOptions({ options: menu }))
        if (window.location.pathname === pageRoutes.no_access)
            return navigate(sidebarKeys[menu[0]?.key]?.route)
        return
    }
    menu?.forEach((item) => {
        // console.log(role?.capabilities, item?.capability_id)
        if (role?.capabilities.includes(item.capability_id))
            hasAccess.push(item)
        if (item?.capability_id === 'all' || isSuperAdminByEmail(user?.username))
            hasAccess.push(item)
    })
    dispatch(changeSideOptions({ options: hasAccess }))
    if (window.location.pathname === pageRoutes.no_access)
        navigate(sidebarKeys[hasAccess[0]?.key]?.route)

}

const checkAccess = (...params) => {
    let [navigate, current, pageKey] = params;
    let { sideOptions = [], role = null,user =null} = current;
    let currentPage = sideOptions?.filter((item) => item.key === (pageKey)?.toString())
    if ((!role || role?.capabilities?.includes(access_capabilities.view_all)) && ( !isSuperAdminByEmail(user?.username)))
        return
    if (!currentPage?.length && ( !isSuperAdminByEmail(user?.username)))
        return navigate(sideOptions[0]?.route, sideOptions[0]?.key)
    if (!role?.capabilities?.includes(currentPage[0]?.capability_id) && ( !isSuperAdminByEmail(user?.username)))
        return navigate(sideOptions[0]?.route, sideOptions[0]?.key)
}

export {
    getRolesList,
    extractRoles,
    controlAccess,
    checkAccess
}
